export type CrmLinkDiscountMode =
  | 'first_only'
  | 'every_payment'
  | 'renewal_only'

export const CRM_LINK_DISCOUNT_MODE_OPTIONS: {
  value: CrmLinkDiscountMode
  label: string
}[] = [
  { value: 'first_only', label: 'Скидка только на первую оплату' },
  { value: 'every_payment', label: 'Скидка на каждую оплату' },
  { value: 'renewal_only', label: 'Скидка только на продление' },
]

/** Режимы без фиксации периода (верхнее поле скидки). */
export const CRM_LINK_UNFIXED_DISCOUNT_MODE_OPTIONS =
  CRM_LINK_DISCOUNT_MODE_OPTIONS.filter(
    (item) => item.value !== 'renewal_only',
  )

export const isCrmLinkDiscountModeTariff = (tariffType?: string | null) =>
  tariffType === 'month' ||
  tariffType === 'stream_custom_period' ||
  tariffType === 'stream_custom_days' ||
  tariffType === 'stream_custom_weeks'

export const resolveCrmLinkDiscountMode = ({
  discount,
  discountMode,
  applyDiscountEachPayment,
  isPeriodFixed,
}: {
  discount?: number | null
  discountMode?: CrmLinkDiscountMode | null
  applyDiscountEachPayment?: boolean | null
  isPeriodFixed?: boolean
}): CrmLinkDiscountMode | null => {
  if (!(Number(discount) > 0)) return null

  if (
    discountMode === 'first_only' ||
    discountMode === 'every_payment' ||
    discountMode === 'renewal_only'
  ) {
    // Фиксация → только продление; без фиксации renewal_only не держим.
    if (isPeriodFixed) return 'renewal_only'
    if (discountMode === 'renewal_only') return 'first_only'
    return discountMode
  }

  if (isPeriodFixed) return 'renewal_only'
  return applyDiscountEachPayment ? 'every_payment' : 'first_only'
}

/** price «сейчас» из полной базы и режима. */
export const getCrmLinkPriceNowFromBase = (
  fullBasePrice: number,
  discount: unknown,
  mode: CrmLinkDiscountMode | null,
) => {
  const base = Math.max(0, Number(fullBasePrice) || 0)
  const discountValue = Math.max(0, Number(discount) || 0)
  if (!mode || discountValue <= 0) return base
  if (mode === 'renewal_only') return base
  return Math.max(0, Math.round((base - discountValue) * 100) / 100)
}

/** Сумма продления для превью. */
export const getCrmLinkRenewalPriceFromBase = (
  fullBasePrice: number,
  discount: unknown,
  mode: CrmLinkDiscountMode | null,
) => {
  const base = Math.max(0, Number(fullBasePrice) || 0)
  const discountValue = Math.max(0, Number(discount) || 0)
  if (!mode || discountValue <= 0) return base
  if (mode === 'first_only') return base
  return Math.max(0, Math.round((base - discountValue) * 100) / 100)
}

export const getCrmLinkDiscountModeLabel = (
  mode: CrmLinkDiscountMode | null | undefined,
) => {
  switch (mode) {
    case 'first_only':
      return 'только на первую оплату'
    case 'every_payment':
      return 'на каждую оплату'
    case 'renewal_only':
      return 'только на продление'
    default:
      return null
  }
}

/** Legacy flag из режима (бэк тоже синхронизирует). */
export const discountModeToApplyEachPayment = (
  mode: CrmLinkDiscountMode | null,
) => mode === 'every_payment'
